import React, {Component, Fragment} from "react";
import {Link} from "react-router-dom";
import styled from 'styled-components'
import MaskedInput from 'react-text-mask'
import ReCAPTCHA from "react-google-recaptcha";
import axios from "axios/index";

class Connect extends Component {
    constructor(props) {
        super(props)
        this.state = {
            captchaSiteKey: '6LeP-1wUAAAAAPLuuewMOW3derEmWFozTSOrk-xa',
            contract: '',
            name: '',
            email: '',
            address: '',
            phone: '',
            captcha: '',
            error: '',
            isSubmitted: false,
        }
    }

    handleChangeInput = (e, field) => {
        this.setState({[field]: e.target.value})
        e.target.setCustomValidity('')
    }

    handleChangePhone = (e) => {
        const value = e.target.value.replace(/\D+/g,"")

        this.setState({
            phone: '+' + value
        })
        e.target.setCustomValidity('')
    }

    handleSubmit = (e) => {
        e.preventDefault()
        const isPhoneValidated = this.validatePhone()
        const isEmailValidated = this.validateEmail()
        if (!isEmailValidated) this.setState({error: 'Проверьте правильность ввода почты'})
        else if (!isPhoneValidated) this.setState({error: 'Проверьте правильность ввода телефона'})
        else if (!this.state.captcha) this.setState({error: 'Пройдите проверку в виде капчи'})
        else {
            const request = {
                contract: this.state.contract,
                name: this.state.name,
                email: this.state.email,
                address: this.state.address,
                phone: this.state.phone,
                captcha: this.state.captcha,
            }
            axios.post('/api/user/register/', request).then(res => {
                this.setState({error: '', isSubmitted: true})
            }).catch(err => {
                let error = err.response.data.error || 'Что-то пошло не так...'
                this.setState({error})
            })
        }
    }

    validateEmail = () => {
        const pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
        const email = this.state.email
        return pattern.test(email)
    }

    validatePhone = () => {
        return this.state.phone.length === 12
    }

    handleEnter = (e) => {
        if (e.key === "Enter") this.submit()
    }

    onChangeCaptcha = (value) => {
        this.setState({captcha: value})
    }

    invalidFieldHandler = (e) => {
        e.target.setCustomValidity('Заполните это поле')
    }

    componentDidMount() {
        document.addEventListener("keydown", this.handleEnter)
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleEnter)
    }

    render() {
        const {contract, name, email, address, phone, error, isSubmitted} = this.state

        return (
            <Content>
                <div className={`form ${this.state.isSubmitted ? 'submitted' : ''}`}>
                    {!isSubmitted ?
                        <Fragment>
                            <h2 className="title">ПОДКЛЮЧЕНИЕ ЛИЧНОГО КАБИНЕТА</h2>
                            <form className="authForm" onSubmit={this.handleSubmit}>
                                <label className="field">
                                    <span className="field__text">Номер договора(ов)</span>
                                    <input className="field__input" type="text"
                                           onChange={(e) => this.handleChangeInput(e, 'contract')}
                                           value={contract}
                                           required
                                           onInvalid={this.invalidFieldHandler}
                                    />
                                </label>
                                <label className="field">
                                    <span className="field__text">ФИО или наименование организации</span>
                                    <input className="field__input" type="text"
                                           onChange={(e) => this.handleChangeInput(e, 'name')}
                                           value={name}
                                           required
                                           onInvalid={this.invalidFieldHandler}
                                    />
                                </label>
                                <label className="field">
                                    <span className="field__text">Адрес электронной почты</span>
                                    <input className="field__input" type="text"
                                           onChange={(e) => this.handleChangeInput(e, 'email')}
                                           value={email}
                                           required
                                           onInvalid={this.invalidFieldHandler}
                                    />
                                </label>
                                <label className="field">
                                    <span className="field__text">Адрес объекта охраны</span>
                                    <input className="field__input" type="text"
                                           onChange={(e) => this.handleChangeInput(e, 'address')}
                                           value={address}
                                           required
                                           onInvalid={this.invalidFieldHandler}
                                    />
                                </label>
                                <label className="field">
                                    <span className="field__text">Контактный телефон</span>
                                    <MaskedInput className="field__input"
                                                 mask={['+', '7', ' ', '(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, '-', /\d/, /\d/]}
                                                 onChange={this.handleChangePhone}
                                                 value={phone}
                                                 required
                                                 onInvalid={this.invalidFieldHandler}
                                    />
                                </label>

                                <div className="captchaBlock">
                                    <div className="captchaBlock__text">
                                        Эта проверка поможет нам отличить хороших людей от нехороших ботов :)
                                    </div>
                                    <ReCAPTCHA
                                        sitekey={this.state.captchaSiteKey}
                                        onChange={this.onChangeCaptcha}
                                    />
                                </div>

                                <button className="button">ПОДКЛЮЧИТЬ</button>
                                <div className="error">{error}</div>
                            </form>
                        </Fragment>
                        :
                        <Fragment>
                            <div className="icon" />
                            <div className="text">
                                ЗАЯВКА НА ПОДКЛЮЧЕНИЕ ЛИЧНОГО КАБИНЕТА
                                ОТПРАВЛЕНА НА РАССМОТРЕНИЕ.
                            </div>
                            <div className="text">
                                ОЖИДАЙТЕ ЭЛ. ПИСЬМО С ДАЛЬНЕЙШИМИ ИНСТРУКЦИЯМИ.
                            </div>
                            <Link className="button" to="/login">ХОРОШО</Link>
                        </Fragment>
                    }
                </div>
            </Content>
        )
    }
}

const Content = styled.div`
  padding: 0 12px;

  .form {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    width: 100%;
    max-width: 900px;
    min-height: 325px;
    margin: 3rem auto;
    padding: 50px 100px;
    background-color: #E5F3FC;

    @media (max-width: 600px) {
      flex-direction: column;
      padding: 50px 30px;
    }

    &.submitted {
      max-width: 700px;
      justify-content: space-between;
    }
  }

  .title {
    font-size: 28px;
    line-height: 38px;
    text-align: center;

    @media (max-width: 600px) {
      font-size: 22px;
      line-height: 28px;
    }
  }

  .authForm {
    width: 100%;
  }

  .field {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin: 16px 0;

    @media (max-width: 767px) {
      flex-direction: column;
    }

    &__text {

      &::after {
        content: '*';
        color: red;
        margin-left: 3px;
      }
    }

    &__input {
      flex-grow: 1;
      margin-left: 10px;
      border: none;
      max-width: 400px;
      height: 30px;
      padding: 0 5px;

      @media (max-width: 767px) {
        margin-left: 0;
        margin-top: 3px;
      }

      &:focus {
        outline: none;
      }
    }
  }

  .captchaBlock {
    position: relative;
    width: 100%;
    min-height: 100px;
    border: 2px solid white;

    margin: 50px 0 40px 0;
    padding: 20px 15px 15px 15px;

    &::before {
      content: 'Проверочный код';
      display: block;
      background-color: #E5F3FC;
      padding: 0 5px;
      position: absolute;
      top: -12px;
      left: 10px;
      font-size: 14px;
    }

    &__text {
      font-size: 14px;
    }
  }

  .button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 2px 0;
    background-color: white;
    font-size: 18px;
    border: none;
    cursor: pointer;
    transition: 0.3s;
    color: #212529;
    text-align: center;

    @media (max-width: 600px) {
      font-size: 16px;
      line-height: 18px;
      padding: 4px 0;
    }

    &:hover {
      background-color: #f8f8f8;
      text-decoration: none;
    }
  }

  .error {
    font-size: 16px;
    color: red;
    text-align: center;
    margin: 10px 0 -30px 0;
  }

  .icon {
    width: 80px;
    height: 40px;
    background-image: url(data:image/gif;base64,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);
  }

  .text {
    text-align: center;
    line-height: 26px;
  }
`

export default Connect;
